import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userSlice';
import coreReducer from './reducers/coreSlice';
import newsletterReducer from './reducers/newsletterSlice';
import landingPagesReducer from './reducers/landingPagesSlice';
import mmsReducer from './reducers/mmsSlice';
import automationsReducer from './reducers/automationsSlice';
import notificationReducer from './reducers/notificationSlice';
import notificationUpdateSlice from './reducers/notificationUpdateSlice';
import smsReducer from './reducers/smsSlice';
import dashboardReducer from './reducers/dashboardSlice';
import recipientReportsReducer from './reducers/recipientsReportSlice';
import shortcutReducer from './reducers/shortcutSlice';
import paymentReducer from './reducers/paymentSlice';
import commonReducer from './reducers/commonSlice';
import siteTrackingReducer from './reducers/siteTrackingSlice';
import clientReducer from './reducers/clientSlice';
import campaignReducer from './reducers/campaignEditorSlice';
import groupSlice from './reducers/groupSlice';
import reportSlice from './reducers/reportSlice';
import ConnectorsSlice from './reducers/ConnectorsSlice';
import galleryReducer from './reducers/gallerySlice'
import whatsappReducer from './reducers/whatsappSlice'
import AccountSettingsSlice from './reducers/AccountSettingsSlice';
import DynamicGroupsSlice from './reducers/DynamicGroupsSlice';
import DomainVerificationSlice from './reducers/DomainVerificationSlice';
import productSlice from './reducers/productSlice';
import ExtraFieldsSlice from './reducers/ExtraFieldsSlice';
import AffiliateSlice from './reducers/AffiliateSlice';
import SubAccountSlice from './reducers/SubAccountSlice';
import BillingSlice from './reducers/BillingSlice';
import SubUserSlice from './reducers/SubUserSlice';
import AiSlice from './reducers/AISlice';
import linksClicksReportSlice from './reducers/linksClicksReportSlice';
import popupTriggersReducer from './reducers/popupTriggersSlice';
import PopupSlice from './reducers/PopupSlice';
import popUpManagementReducer from './reducers/popUpManagementSlice';

import aiChatReducer from './reducers/aiChatSlice';
import supportChatReducer from './reducers/supportChatSlice';
import TiersSlice from './reducers/TiersSlice';
import emailTierScalingReducer from './reducers/emailTierScalingSlice';
import helpDrawerReducer from './reducers/helpDrawerSlice';
import contactSupportReducer from './reducers/contactSupportSlice';
import dataSourcesReducer from './reducers/dataSourcesSlice';
import smartSendReducer from './reducers/smartSendSlice';
import smartSendWhatsAppReducer from './reducers/smartSendWhatsAppSlice';
import sendSearchReducer from './reducers/sendSearchSlice';
import clalCenterReducer from './reducers/clalCenterSlice';
import proTrialReducer from './reducers/ProTrialSlice';


export default configureStore({
  reducer: {
    popupTriggers: popupTriggersReducer,
    popUpManagement: popUpManagementReducer,
    core: coreReducer,
    user: userReducer,
    newsletter: newsletterReducer,
    landingPages: landingPagesReducer,
    mms: mmsReducer,
    automations: automationsReducer,
    notification: notificationReducer,
    notificationUpdate: notificationUpdateSlice,
    sms: smsReducer,
    dashboard: dashboardReducer,
    recipientReports: recipientReportsReducer,
    shortcuts: shortcutReducer,
    payment: paymentReducer,
    common: commonReducer,
    client: clientReducer,
    campaignEditor: campaignReducer,
    siteTracking: siteTrackingReducer,
    group: groupSlice,
    report: reportSlice,
    gallery: galleryReducer,
    connectors: ConnectorsSlice,
    whatsapp: whatsappReducer,
    accountSettings: AccountSettingsSlice,
    dynamicGroups: DynamicGroupsSlice,
    domainVerification: DomainVerificationSlice,
    product: productSlice,
    extraFields: ExtraFieldsSlice,
    affiliates: AffiliateSlice,
    subAccount: SubAccountSlice,
    billing: BillingSlice,
    subUser: SubUserSlice,
    Ai: AiSlice,
    linksClicksReportSlice: linksClicksReportSlice,
    popup: PopupSlice,
    aiChat: aiChatReducer,
    supportChat: supportChatReducer,
    tiers: TiersSlice,
    emailTierScaling: emailTierScalingReducer,
    helpDrawer: helpDrawerReducer,
    contactSupport: contactSupportReducer,
    dataSources: dataSourcesReducer,
    smartSend: smartSendReducer,
    smartSendWa: smartSendWhatsAppReducer,
    sendSearch: sendSearchReducer,
    clalCenter: clalCenterReducer,
    proTrial: proTrialReducer,
  },
});
